import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { Grid, media } from '@simplywallst/ui-core';

import { RouterLink } from '@redux-first-router-link';

import { TableRowCell, TableRow } from '../../Table';

const cubicBezier = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const Chart = styled('div')`
  margin-top: 0;
  padding-left: 0;
  padding-right: 0;

  ${media.xsOnly`
    width: calc(100% + 40px);
    transform: translateX(-40px);
  `}
`;

export const Returns = styled(Grid)`
  transform: translateY(8px);
`;

export const CellRouterLink = styled(RouterLink)<{
  $alignItems?: CSSProperties['alignContent'];
  $justifyContent?: CSSProperties['justifyContent'];
  $flexDirection?: CSSProperties['flexDirection'];
}>`
  text-decoration: unset;
  color: unset;
  display: flex;
  ${({ $flexDirection = 'row' }) => `flex-direction: ${$flexDirection};`}
  ${({ $alignItems = 'center' }) => `align-items: ${$alignItems};`}
    ${({ $justifyContent = 'flex-start' }) =>
    `justify-content: ${$justifyContent};`}
`;

export const WatchlistTableRow = styled(TableRow)`
  > ${TableRowCell} {
    transition: background-color 0.4s ${cubicBezier};
    padding: 0;
  }

  ${media.lgUp`
    &:hover {
      > ${TableRowCell} {
        background-color: ${({ theme }) => theme.color.phantom};
      }
    }
  `}
`;

export const SkeletonTableRow = styled(TableRow)`
  > ${TableRowCell} > div {
    position: relative;
    ${media.lgUp`
      display: flex;
      align-items: center;
    `}
  }
`;

export const TooltipLabel = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: pointer;
  display: inline-block;
  user-select: none;
`;
